module.exports = __webpack_public_path__ + "static/img/color_pillar.0fb6064.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/color_pillar.png
// module id = 511
// module chunks = 1